<template>
  <svg viewBox="7.5 7.5 35 35">
    <g id="Iconen">
      <g>
        <rect x="24.39" y="20.54" class="st0" width="8.29" height="8.29" />
        <line class="st0" x1="28.54" y1="20.54" x2="28.54" y2="28.83" />
        <line class="st0" x1="24.39" y1="24.69" x2="32.69" y2="24.69" />
        <polyline
          class="st0"
          points="13.34,19.56 16.98,16.28 16.98,16.28 20.63,19.56 		"
        />
        <line class="st0" x1="16.98" y1="16.38" x2="16.98" y2="29.36" />
        <polyline class="st0" points="13,13.11 37.3,13.11 37.3,37.41 		" />
      </g>
    </g>
    <g id="kader" class="st1">
      <g class="st2">
        <g>
          <g>
            <path
              d="M46.5,1.1c1.47,0,2.66,1.19,2.66,2.66v42.72c0,1.47-1.19,2.66-2.66,2.66H3.77c-1.47,0-2.66-1.19-2.66-2.66V3.76
					c0-1.47,1.19-2.66,2.66-2.66H46.5 M46.5,0.1H3.77c-2.02,0-3.66,1.64-3.66,3.66v42.72c0,2.02,1.64,3.66,3.66,3.66H46.5
					c2.02,0,3.66-1.64,3.66-3.66V3.76C50.16,1.73,48.52,0.1,46.5,0.1L46.5,0.1z"
            />
          </g>
        </g>
        <rect x="5.59" y="5.58" class="st3" width="39.08" height="39.08" />
      </g>
      <g class="st2">
        <g>
          <path
            d="M46.5,1.1c1.47,0,2.66,1.19,2.66,2.66v42.72c0,1.47-1.19,2.66-2.66,2.66H3.77c-1.47,0-2.66-1.19-2.66-2.66V3.76
				c0-1.47,1.19-2.66,2.66-2.66H46.5 M46.5,0.1H3.77c-2.02,0-3.66,1.64-3.66,3.66v42.72c0,2.02,1.64,3.66,3.66,3.66H46.5
				c2.02,0,3.66-1.64,3.66-3.66V3.76C50.16,1.73,48.52,0.1,46.5,0.1L46.5,0.1z"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconPlafond extends Vue {}
</script>

<style scoped type="text/css">
.st0 {
  fill: none;
  stroke: #000000;
  stroke-miterlimit: 10;
}

.st1 {
  display: none;
}

.st2 {
  display: inline;
}

.st3 {
  fill: none;
  stroke: #29abe2;
  stroke-miterlimit: 10;
}
</style>
